import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  overlay: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%',
    zIndex: 1400,
    pointerEvents: 'none',
  },
  consentBar: {
    backgroundColor: '#F4F4F8',
    padding: theme.spacing(2, 2.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    borderTop: '1px solid #EDEDF5',
    position: 'absolute',
    bottom: 0,
  },
  consentText: {
    fontSize: 13,
    color: '#555',
    lineHeight: 1.5,
  },
  consentLink: {
    color: '#5959EB',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  agreeBtn: {
    alignSelf: 'center',
    backgroundColor: '#5959EB',
    color: 'white',
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1, 3),
    borderRadius: theme.spacing(3),
    '&:hover': {
      backgroundColor: '#4343C8',
    },
  },
}));

interface ConsentBarProps {
  onAgree: () => void;
}

export const ConsentBar = ({ onAgree }: ConsentBarProps) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.overlay} />
      <Box className={classes.consentBar}>
        <Typography className={classes.consentText}>
          <FormattedMessage
            id="chatbot.consent.text"
            values={{
              privacyLink: (
                <a
                  href="https://www.katalon.com/terms/#privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.consentLink}
                >
                  <FormattedMessage id="chatbot.consent.privacy.link" />
                </a>
              ),
              cookieLink: (
                <a
                  href="https://www.katalon.com/terms/katalon/cookie-notice/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.consentLink}
                >
                  <FormattedMessage id="chatbot.consent.cookie.link" />
                </a>
              ),
            }}
          />
        </Typography>
        <Button className={classes.agreeBtn} onClick={onAgree}>
          <FormattedMessage id="chatbot.consent.agree.btn" />
        </Button>
      </Box>
    </>
  );
};
